import { apiClient, API_CONFIG } from '../config/api'
import { AppParameter, ParameterRequest } from '../types/settings'

const BM = API_CONFIG.BM_BASE_URL

export const settingsService = {
  async getParameters(group?: string, editable?: boolean): Promise<AppParameter[]> {
    const sp = new URLSearchParams()
    if (group) sp.append('group', group)
    if (editable !== undefined) sp.append('editable', editable.toString())
    const { data } = await apiClient.get(`${BM}/settings/parameters?${sp}`)
    return data.data ?? data
  },

  async getParameter(key: string): Promise<AppParameter> {
    const { data } = await apiClient.get(`${BM}/settings/parameters/${encodeURIComponent(key)}`)
    return data.data
  },

  async updateParameter(key: string, value: string): Promise<AppParameter> {
    const { data } = await apiClient.put(`${BM}/settings/parameters/${encodeURIComponent(key)}`, { value })
    return data.data
  },

  async createParameter(request: ParameterRequest): Promise<AppParameter> {
    const { data } = await apiClient.post(`${BM}/settings/parameters`, {
      key: request.key,
      value: request.value,
      group_name: request.groupName,
      editable: request.editable ?? true,
      description: request.description,
      value_type: request.valueType ?? 'STRING',
    })
    return data.data
  },

  async deleteParameter(key: string): Promise<void> {
    await apiClient.delete(`${BM}/settings/parameters/${encodeURIComponent(key)}`)
  },

  async getParameterGroups(): Promise<string[]> {
    const { data } = await apiClient.get(`${BM}/settings/groups`)
    return data.data ?? data
  },

  async bulkUpdateParameters(updates: { key: string; value: string }[]): Promise<void> {
    await apiClient.post(`${BM}/settings/parameters/bulk-update`, { updates })
  },

  async exportParameters(group?: string): Promise<string> {
    const params = group ? `?group=${encodeURIComponent(group)}` : ''
    const { data } = await apiClient.get(`${BM}/settings/parameters/export${params}`)
    return data
  },

  async importParameters(jsonData: string): Promise<void> {
    await apiClient.post(`${BM}/settings/parameters/import`, { data: jsonData })
  },

  async resetParametersToDefaults(group: string): Promise<void> {
    await apiClient.post(`${BM}/settings/parameters/reset`, { group })
  },
}
